export default "__VITE_ASSET__Drje_J1a__"